import React from 'react';
import styles from './ui-skeleton.module.scss';

export interface UISkeletonProps {
    width?: string | number;
    height?: string | number;
    radius?: 'sm' | 'md' | 'lg' | 'full';
    /** Fills the parent's height — use inside a sized container (e.g. an image area). */
    fill?: boolean;
    className?: string;
}

function toCssSize(value: string | number | undefined): string | undefined {
    if (value === undefined) return undefined;
    return typeof value === 'number' ? `${value}px` : value;
}

export function UISkeleton({
    width,
    height,
    radius = 'sm',
    fill = false,
    className = '',
}: UISkeletonProps) {
    const classes = [
        styles.skeleton,
        styles[`radius-${radius}`],
        fill ? styles.fill : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <span
            aria-hidden="true"
            className={classes}
            style={{ width: toCssSize(width), height: toCssSize(height) }}
        />
    );
}

export default UISkeleton;
